export const NAMESPACE = "lenndFlags";

export const actionTypes = {
  FETCH_FLAGS_REQUEST: `${NAMESPACE}/FETCH_FLAGS_REQUEST`,
  FETCH_FLAGS_SUCCESS: `${NAMESPACE}/FETCH_FLAGS_SUCCESS`,
  FETCH_FLAGS_FAILURE: `${NAMESPACE}/FETCH_FLAGS_FAILURE`
};
